import axios from 'axios';
import { getStoredToken } from '../../../login/api/loginApi';
import { attachAuthInterceptors } from '../../../_shared/auth/authInterceptor';

const BASE_URL = import.meta.env.VITE_GATEWAY_ADMIN_BASE ?? '/api/eraf/gateway';

export const gatewayApiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachAuthInterceptors(gatewayApiClient);

// Request interceptor — attach auth token (localStorage 우선, 없으면 sessionStorage)
gatewayApiClient.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor — unwrap ApiResponse<T>
gatewayApiClient.interceptors.response.use(
  (response) => {
    // Unwrap { success, data, error, traceId } envelope if present
    if (response.data && typeof response.data === 'object' && 'success' in response.data) {
      if (!response.data.success) {
        return Promise.reject({
          message: response.data.error?.message ?? 'Unknown error',
          code: response.data.error?.code,
          traceId: response.data.traceId,
        });
      }
      response.data = response.data.data;
    }
    return response;
  },
  (error) => {
    const traceId = error.response?.headers?.['x-trace-id'];
    const message =
      error.response?.data?.error?.message ??
      error.response?.data?.message ??
      error.message ??
      'Network error';
    return Promise.reject({ message, traceId, code: error.response?.data?.error?.code });
  }
);

export { BASE_URL };
